import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCandidateObjectiveWithBaselineIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	color: "gray",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		height: "100%",
		width: "100%",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("line", {
		stroke: "black",
		strokeWidth: 4,
		x1: 2,
		x2: 2,
		y1: 0,
		y2: 24
	})]
});
export default SvgCandidateObjectiveWithBaselineIcon;
